export const PRACTICE_MODES = {
  OLL: {
    EXECUTION: 'OLL_EXECUTION',
    RECOGNITION: 'OLL_RECOGNITION'
  },
  PLL: {
    EXECUTION: 'PLL_EXECUTION',
    RECOGNITION: 'PLL_RECOGNITION'
  }
}; 